import { FC } from 'react'
import SliderRC from 'rc-slider'
import 'rc-slider/assets/index.css';
import { SliderContainer } from './styles'

interface SliderProps {
  value?: number;
  onChange?: (value: number | number[]) => void;
}

const Slider: FC<SliderProps> = ({ value, onChange }) => {
  return (
    <SliderContainer>
      <SliderRC
        value={value}
        onChange={onChange}
        min={0}
        max={100}
        step={5}
        dots
        handleStyle={{
          width: '24px',
          height: '24px',
          background: '#FFF',
          border: '6px solid #3D6666',
          boxShadow: 'none',
          opacity: '1',
          marginTop: '-6px'
        }}
        trackStyle={{
          height: '8px',
          background: '#3D6666',
          marginTop: '1px'
        }}
        railStyle={{
          background: '#EBF2F2',
          height: '8px',
          marginTop: '1px'
        }}
        dotStyle={{
          width: '2px',
          height: '2px',
          maxWidth: '2px',
          maxHeight: '2px',
          minWidth: '2px',
          minHeight: '2px',
          background: '#3D6666',
          opacity: '1',
          border: 'none'
        }}
        activeDotStyle={{
          width: '2px',
          height: '2px',
          maxWidth: '2px',
          maxHeight: '2px',
          minWidth: '2px',
          minHeight: '2px',
          background: '#FFF',
          opacity: '1',
          border: 'none'
        }}
      />
    </SliderContainer>
  )
}

export default Slider